import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import FileCopyIcon from "@mui/icons-material/FileCopyOutlined";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import ShareIcon from "@mui/icons-material/Share";
import { MdOutlineDirectionsCarFilled } from "react-icons/md";
import { MdOutlineHomeWork } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useFetchData } from "../hooks/useFetchData";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import project from "../component/images/project.png"
import { MdOutlinePersonAdd } from "react-icons/md";

export default function FloatingMenu() {

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { t } = useTranslation();
  const user_id = localStorage.getItem("user_id");
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const loc = localStorage.getItem("userId") == 1
  const actions = [
    { icon: <MdOutlineHomeWork size={24} onClick={() => fetchData('1')} />, name: t("nav.newrealestate") },
    { icon: <MdOutlineDirectionsCarFilled size={24} onClick={() => fetchData('2')} />, name: t("nav.newcar") },
    ...(loc
      ? [{
        icon: <MdOutlinePersonAdd size={24} onClick={() => fetchData('3')} />,
        name: t("nav.developer")
      }]
      : []), ...(loc
        ? [{ icon: <img src={project} style={{ width: "20px", height: "20px" }} onClick={() => fetchData('4')} />, name: t("nav.project") }]
        : []),
    // { icon: <PrintIcon />, name: 'Print' },
    // { icon: <ShareIcon />, name: 'Share' },
  ];
  const fetchData = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}checkSubs?user_id=${user_id}`
      );
      setData(response.data.data);
      console.log("hi", response?.data?.data);
      if (id == "1")
        (await response?.data?.data) === true
          ? navigate("/Addnew")
          : navigate("/Resubscribe");
      if (id == "2")
        (await response?.data?.data) === true
          ? navigate("/AddnewCar")
          : navigate("/Resubscribe");
      if (id == "3")
        (await response?.data?.data) === true
          ? navigate("/developer")
          : navigate("/Resubscribe");
      if (id == "4")
        (await response?.data?.data) === true
          ? navigate("/project")
          : navigate("/Resubscribe");

      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SpeedDial
      ariaLabel="SpeedDial controlled open example"
      sx={{ position: "fixed", bottom: 40, right: 40, }}
      FabProps={{
        sx: {
          bgcolor: 'rgb(53, 51, 51)', // Your custom background color
          '&:hover': {
            bgcolor: 'rgb(53, 51, 51)',

          },
        },
      }}
      icon={<SpeedDialIcon sx={{
        '& .MuiSpeedDialIcon-icon': {
          fontSize: 22, // Adjust the icon size

        },
        '& .MuiSpeedDialIcon-openIcon': {
          fontSize: 22, // Adjust the open icon size if you're using openIcon
        },
      }} />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={handleClose}
          tooltipOpen
        />
      ))}
    </SpeedDial>
  );
}
